module.exports = __webpack_public_path__ + "static/4_2_nearest-neighbor-5ea05e48e9bc1e034df48a09e9345eec.svg";